<template>
  <v-app style="background-color: #f3f4f7">
    <v-app-bar
      app
      clipped-left
    >
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
      />

      <router-link
        :to="{name: 'painel'}"
        class="ml-2"
        style="height: 100%;"
      >
        <img
          src="@/assets/keystone-logo.png"
          width="200px"
        >
      </router-link>

      <v-spacer />

      <v-menu
        :close-on-content-click="false"
        :nudge-width="300"
        :max-width="300"
        offset-y
        bottom
      >
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-avatar color="indigo">
              <template v-if="userIntranet.avatar">
                <img
                  :src="userIntranet.avatar"
                  :alt="userIntranet.name"
                >
              </template>
              <v-icon
                v-else
                dark
              >
                mdi-account-circle
              </v-icon>
            </v-avatar>
          </v-btn>
        </template>

        <v-card>
          <v-row>
            <v-col class="text-center mt-2">
              <v-avatar
                v-if="userIntranet.avatar"
                size="62"
              >
                <img
                  :src="userIntranet.avatar"
                  :alt="userIntranet.name"
                >
              </v-avatar>
              <v-icon
                v-else
              >
                mdi-camera
              </v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center mb-2">
              <p> {{ userIntranet.name }}</p>
              <v-btn
                rounded
                outlined
                color="indigo"
                @click="openProfileDialog"
              >
                Gerenciar conta
              </v-btn>
            </v-col>
          </v-row>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              rounded
              outlined
              text
              color="primary"
              @click="logout()"
            >
              Sair
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      clipped
      app
    >
      <NavMenu />
    </v-navigation-drawer>
    <v-main>
      <slot />
    </v-main>
  </v-app>
</template>

<script>
import ProfileDialog from '@/components/ProfileDialog.vue'
import NavMenu from '@/components/NavMenu.vue'
import utils from '@/api/utils.js'

export default {
  components: {
    NavMenu
  },

  data: () => ({
    badge: false,
    actionAvatar: false,
    userIntranet: {},
    drawer: true,
    fab: false,
    renderComponent: 0,
    dialogEditPerfil: false,
    dialogEditAvatar: false,
    dialogDeleteAvatar: false,
    errors: [],
    stateErrors: []
  }),
  created () {
    this.fetchAll()
  },
  methods: {
    async fetchAll () {
      await this.getIntranetUser()
    },
    getErrors (data) {
      if (data.data.errors) {
        this.errors = utils.setErrorsData(data.data.errors)
        this.stateErrors = utils.setStateErrors(data.data.errors)
      } else {
        throw (data)
      }
    },
    async getIntranetUser () {
      try {
        await this.$api.me()
      } catch (e) {
        // console.log(e)
      }
      this.userIntranet = utils.getUser()
    },
    async updateMe (data) {
      try {
        await this.$api.updateUser(data, this.userIntranet.id)
        this.dialogEditPerfil = false
        this.fetchAll()
      } catch (e) {
        this.getErrors(e.response)
      }
    },
    async openProfileDialog () {
      this.$dialog.custom(ProfileDialog).with({ user: this.userIntranet }).show()
        .then((data) => {
          this.updateMe(data)
        })
    },
    async logout () {
      try {
        await this.$api.logout()
        this.$router.push({ name: 'index' })
      } catch (e) {
        this.getErrors(e.response)
      }
    }
  }
}
</script>
